const generateStableId = (text, type) => {
  const cleanText = text.toLowerCase().trim();
  let hash = 0;
  for (let i = 0; i < cleanText.length; i++) {
    const char = cleanText.charCodeAt(i);
    hash = ((hash << 5) - hash) + char;
    hash = hash & hash;
  }
  return `${type}_${Math.abs(hash)}`;
};

const saveVocabularyToBackend = async (videoId, vocabulary) => {
  try {
    const response = await fetch(`/api/vocabulary/video/${videoId}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        words: vocabulary.words.map(w => ({
          word: w.word,
          phonetic: w.phonetic || '',
          partOfSpeech: w.partOfSpeech || '',
          definition: w.definition || '',
          chineseTranslation: w.chineseTranslation || '',
          synonyms: w.synonyms || '',
          cambridgeLevel: w.cambridgeLevel || '',
          sentence: w.sentence || '',
          sentenceChinese: w.sentenceChinese || ''
        })),
        phrases: vocabulary.phrases.map(p => ({
          phrase: p.phrase,
          phonetic: p.phonetic || '',
          partOfSpeech: p.partOfSpeech || '',
          chineseTranslation: p.chineseTranslation || '',
          definition: p.definition || '',
          synonyms: p.synonyms || '',
          cambridgeLevel: p.cambridgeLevel || '',
          sentence: p.sentence || '',
          sentenceChinese: p.sentenceChinese || ''
        })),
        scienceVocabulary: vocabulary.expressions.map(e => ({
          expression: e.expression || e.word || e.phrase,
          phonetic: e.phonetic || '',
          partOfSpeech: e.partOfSpeech || '',
          chineseTranslation: e.chineseTranslation || '',
          definition: e.definition || '',
          synonyms: e.synonyms || '',
          cambridgeLevel: e.cambridgeLevel || '',
          sentence: e.sentence || '',
          sentenceChinese: e.sentenceChinese || ''
        }))
      })
    });

    const data = await response.json();
    if (data.success) {
      console.log('词汇已保存到后端:', videoId);
    }
  } catch (error) {
    console.error('保存词汇到后端失败:', error);
  }
};

export const extractAndProcessVocabulary = async (subtitleUrl, videoId, forceRefresh = false) => {
  console.log('=== extractAndProcessVocabulary 开始 ===');
  console.log('subtitleUrl:', subtitleUrl);
  console.log('videoId:', videoId);
  console.log('forceRefresh:', forceRefresh);
  
  try {
    if (!forceRefresh) {
      try {
        console.log('尝试从后端获取已保存的词汇...');
        const backendResponse = await fetch(`/api/vocabulary/video/${videoId}`);
        const backendData = await backendResponse.json();
        
        if (backendData.success && backendData.vocabulary) {
          console.log('从后端获取到已保存的词汇:', backendData.vocabulary);
          
          const vocabulary = {
            words: (backendData.vocabulary.words || []).map(w => ({
              ...w,
              id: generateStableId(w.word, 'word'),
              sentence: w.sentence || '',
              sentenceChinese: w.sentenceChinese || '',
              status: 'unmarked',
              source: 'backend'
            })),
            phrases: (backendData.vocabulary.phrases || []).map(p => ({
              ...p,
              id: generateStableId(p.phrase, 'phrase'),
              sentence: p.sentence || '',
              sentenceChinese: p.sentenceChinese || '',
              status: 'unmarked',
              source: 'backend'
            })),
            expressions: (backendData.vocabulary.expressions || []).map(e => ({
              ...e,
              id: generateStableId(e.expression || e.word || e.phrase, 'expression'),
              sentence: e.sentence || '',
              sentenceChinese: e.sentenceChinese || '',
              status: 'unmarked',
              source: 'backend'
            }))
          };
          
          console.log('转换后的词汇:', vocabulary);
          
          const virtualWords = ['pensive', 'introspective', 'journal', 'break down', 'analytical'];
          const virtualPhrases = ['in my head', 'thought processes'];
          const virtualExpressions = ['overall'];
          
          vocabulary.words = vocabulary.words.filter(word => !virtualWords.includes(word.word));
          vocabulary.phrases = vocabulary.phrases.filter(phrase => !virtualPhrases.includes(phrase.phrase));
          vocabulary.expressions = vocabulary.expressions.filter(expr => {
            const text = expr.expression || expr.word || expr.phrase;
            return !virtualExpressions.includes(text);
          });
          
          console.log('过滤后的词汇:', vocabulary);
          
          if (vocabulary.words.length > 0) {
            console.log('示例单词及例句:', vocabulary.words[0]);
          }
          
          return vocabulary;
        }
      } catch (error) {
        console.log('从后端获取词汇失败，将重新提取:', error);
      }
    }

    console.log('开始重新提取词汇...');
    
    let vocabulary = {
      words: [],
      phrases: [],
      expressions: []
    };

    const subtitleResponse = await fetch(subtitleUrl);
    const subtitleText = await subtitleResponse.text();
    console.log('字幕文件内容长度:', subtitleText.length);

    const subtitles = [];
    const lines = subtitleText.split('\n');
    let currentSubtitle = null;

    for (let i = 0; i < lines.length; i++) {
      const line = lines[i].trim();

      if (line.match(/^\d+$/)) {
        if (currentSubtitle && currentSubtitle.english) {
          subtitles.push(currentSubtitle);
        }
        currentSubtitle = { index: parseInt(line), english: '', chinese: '' };
      } else if (line.match(/^\d{2}:\d{2}:\d{2}/)) {
        continue;
      } else if (line && currentSubtitle) {
        if (!currentSubtitle.english) {
          currentSubtitle.english = line;
        } else if (!currentSubtitle.chinese) {
          currentSubtitle.chinese = line;
        }
      }
    }

    if (currentSubtitle && currentSubtitle.english) {
      subtitles.push(currentSubtitle);
    }

    console.log('解析后的字幕数量:', subtitles.length);

    const smartResponse = await fetch('/api/vocabulary/smart-extract', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        subtitleContent: subtitles.map(s => `${s.english}\n${s.chinese}`).join('\n'),
        videoId: videoId
      })
    });

    const smartData = await smartResponse.json();

    if (smartData.success) {
      console.log('智能词汇提取成功:', smartData);
      
      vocabulary = {
        words: (smartData.words || []).map(w => ({
          ...w,
          id: generateStableId(w.word, 'word'),
          sentence: w.sentence || '',
          sentenceChinese: w.sentenceChinese || '',
          status: 'unmarked',
          source: 'smart'
        })),
        phrases: (smartData.phrases || []).map(p => ({
          ...p,
          id: generateStableId(p.phrase, 'phrase'),
          sentence: p.sentence || '',
          sentenceChinese: p.sentenceChinese || '',
          status: 'unmarked',
          source: 'smart'
        })),
        expressions: (smartData.scienceVocabulary || []).map(e => ({
          ...e,
          id: generateStableId(e.expression || e.word || e.phrase, 'expression'),
          sentence: e.sentence || '',
          sentenceChinese: e.sentenceChinese || '',
          status: 'unmarked',
          source: 'smart'
        }))
      };
      
      console.log('新提取的词汇:', vocabulary);
      if (vocabulary.words.length > 0) {
        console.log('新提取的示例单词及例句:', vocabulary.words[0]);
      }
    }

    if (vocabulary.words.length === 0 && vocabulary.phrases.length === 0 && vocabulary.expressions.length === 0) {
      const response = await fetch(`/api/vocabulary/video/${videoId}`);
      const data = await response.json();

      if (data.success && data.vocabulary) {
        vocabulary = {
          words: (data.vocabulary.words || []).map(w => ({
            ...w,
            id: generateStableId(w.word, 'word'),
            sentence: w.sentence || '',
            sentenceChinese: w.sentenceChinese || ''
          })),
          phrases: (data.vocabulary.phrases || []).map(p => ({
            ...p,
            id: generateStableId(p.phrase, 'phrase'),
            sentence: p.sentence || '',
            sentenceChinese: p.sentenceChinese || ''
          })),
          expressions: (data.vocabulary.expressions || []).map(e => ({
            ...e,
            id: generateStableId(e.expression || e.word || e.phrase, 'expression'),
            sentence: e.sentence || '',
            sentenceChinese: e.sentenceChinese || ''
          }))
        };
      } else {
        const vocabularyKey = `adminVocabulary_${videoId}`;
        const savedVocabulary = localStorage.getItem(vocabularyKey);
        if (savedVocabulary) {
          const parsed = JSON.parse(savedVocabulary);
          vocabulary = {
            words: (parsed.words || []).map(w => ({
              ...w,
              id: generateStableId(w.word, 'word'),
              sentence: w.sentence || '',
              sentenceChinese: w.sentenceChinese || ''
            })),
            phrases: (parsed.phrases || []).map(p => ({
              ...p,
              id: generateStableId(p.phrase, 'phrase'),
              sentence: p.sentence || '',
              sentenceChinese: p.sentenceChinese || ''
            })),
            expressions: (parsed.expressions || []).map(e => ({
              ...e,
              id: generateStableId(e.expression || e.word || e.phrase, 'expression'),
              sentence: e.sentence || '',
              sentenceChinese: e.sentenceChinese || ''
            }))
          };
        }
      }
    }

    const virtualWords = ['pensive', 'introspective', 'journal', 'break down', 'analytical'];
    const virtualPhrases = ['in my head', 'thought processes'];
    const virtualExpressions = ['overall'];

    vocabulary.words = vocabulary.words.filter(word => !virtualWords.includes(word.word));
    vocabulary.phrases = vocabulary.phrases.filter(phrase => !virtualPhrases.includes(phrase.phrase));
    vocabulary.expressions = vocabulary.expressions.filter(expr => {
      const text = expr.expression || expr.word || expr.phrase;
      return !virtualExpressions.includes(text);
    });

    if (vocabulary.words.length > 0 || vocabulary.phrases.length > 0 || vocabulary.expressions.length > 0) {
      console.log('准备保存词汇到后端...');
      await saveVocabularyToBackend(videoId, vocabulary);
    }

    console.log('=== extractAndProcessVocabulary 完成 ===');
    return vocabulary;
  } catch (error) {
    console.error('Failed to extract vocabulary:', error);
    return { words: [], phrases: [], expressions: [] };
  }
};
